module.exports = __webpack_public_path__ + "static/media/beef-explore-more.bb368c09.jpg";